import Axios from 'axios';

const refreshToken = () => Axios.get(`${process.env.REACT_APP_API}/me`);

export { refreshToken };
